export default theme => ({
  subtitle: {
    textTransform: "uppercase",
    fontSize: theme.textSizes[0],
    fontWeight: 500,
    marginBottom: theme.sizes[4],
    color: theme.palette.disabled.main,
  },
  scoreboardPreview: {
    border: "1px solid",
    height: "auto",
    width: "70%",
    backgroundColor: "rgba(0,0,0,0.2)",
  },
  scoreboardPreview_container: {
    textAlign: "center",
  },
  data: {
    marginTop: theme.sizes[3],
  },
  details: {
    padding: "0 24px",
    display: "flex",
    gap: theme.spacing(6)
  },
  column: {
    textAlign: "center",
  },
  dataCard: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: `${theme.spacing(2)}px ${theme.spacing(3)}px`,
    flexBasis: "50%",
    "& div": {
      minWidth: "100%",
    },
  },
  teamName: {
    textTransform: "uppercase",
  },
  teamLogo: {
    height: "30vmin",
  },
  dataCardExternalData: {
    display: "flex",
    flexDirection: "column",
  },
  eventExternalData: {
    textAlign: "left",
  }
});
